export { accordionVariables as accordionTitleVariables } from './accordionVariables';
